var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluetwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.801,
    height: 20.708,
    viewBox: "0 0 24.801 20.708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-twitter",
    "data-name": "Icon feather-twitter",
    d: "M24.8,4.5a11.545,11.545,0,0,1-3.326,1.62,4.745,4.745,0,0,0-8.325,3.177v1.059a11.29,11.29,0,0,1-9.532-4.8s-4.237,9.532,5.3,13.769A12.328,12.328,0,0,1,1.5,21.442c9.532,5.3,21.183,0,21.183-12.18a4.766,4.766,0,0,0-.085-.879A8.177,8.177,0,0,0,24.8,4.5Z",
    transform: "translate(-0.75 -3.657)",
    fill: "none",
    stroke: "#05235c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetwitter);
export default __webpack_public_path__ + "static/media/bluetwitter.712873fe61c7d2c2d03c3b43f6b11167.svg";
export { ForwardRef as ReactComponent };